import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Stack,
} from "@mui/material"
import { Fragment, useEffect } from "react"
import PropSpec from "./PropSpec"
import { useState } from "react"
import ArchiMateElementSelect from "./controls/ArchiMateElementSelect"
import { useMemo } from "react"
import { useSnackbar } from "notistack"
import { GPT_5 } from "../pages/services/chatGenerationServices"
import { getSuggestedTags } from "../pages/services/chatGenerationServices"
import * as Roles from "../pages/services/roleServices"

const ModelEditAddPropertiesDialog = ({
  open,
  onClose,
  accountId,
  viewSetId,
  handleAddProps,
  handleUpdateSuggestedProps,
  purpose,
  view,
  roles,
  // files to use as input when generating properties
  files,
}) => {
  const [elementType, setElementType] = useState("")

  const [selectedGPTModel, setSelectedGPTModel] = useState(GPT_5)

  const [elementProps, setElementProps] = useState([
    { name: "", description: "", auto: false, seq: 1 },
  ])

  const [selectedFile, setSelectedFile] = useState({ name: "" })

  const [override, setOverride] = useState(false)

  const { enqueueSnackbar } = useSnackbar()

  // Get unique 'type' value from view.elements
  const uniqueElementTypes = useMemo(() => {
    if (view) {
      const uniqueTypes = [
        ...new Set(view?.elements.map((element) => element.type)),
      ]

      if (uniqueTypes.length === 1) {
        setElementType(uniqueTypes[0])
      }
      return uniqueTypes
    }
  }, [view])

  const handleGetSuggestedProps = async () => {
    const suggestedTags = await getSuggestedTags({
      view,
      purpose,
      roles,
    })

    handleUpdateSuggestedProps(suggestedTags)

    return suggestedTags
  }

  useEffect(() => {
    if (!roles.includes(Roles.AIM_AI)) {
      setSelectedGPTModel(GPT_5)
    }
  }, [roles])

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Tags</DialogTitle>
      <DialogContent sx={{ maxWidth: "600px" }}>
        <DialogContentText>
          Add tags to generate insights. Tags are key/value pairs that provide
          additional information about the elements in the diagram in relation
          to achieving your goal. e.g. Criticality = High, Risk = Low, etc.
        </DialogContentText>

        <Stack gap={2} sx={{ mt: "30px", mb: "10px" }}>
          <ArchiMateElementSelect
            type={elementType}
            setType={(newType) => {
              if (newType !== "-1") setElementType(newType)
            }}
            label={"Element type to tag"}
            filterTypes={uniqueElementTypes}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            {elementProps.map((prop, index) => (
              <Fragment key={prop.seq}>
                {index > 0 && (
                  <Box sx={{ marginTop: "20px" }}>
                    <Divider />
                  </Box>
                )}

                <PropSpec
                  accountId={accountId}
                  prop={prop}
                  setProp={(newProp) => {
                    const newProps = [...elementProps]
                    newProps[index] = newProp
                    setElementProps(newProps)
                  }}
                  // handleDeleteProp={(seq) => {
                  //   const newProps = elementProps.filter(
                  //     (prop) => prop.seq !== seq
                  //   )
                  //   setElementProps(newProps)
                  // }}
                  handleGetSuggestedTags={handleGetSuggestedProps}
                  setElementType={(elementType) => setElementType(elementType)}
                  suggestedTags={view.suggested_props || []}
                  files={files}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                />
              </Fragment>
            ))}
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          sx={{ textTransform: "none" }}
          onClick={onClose}
          size="small"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{ textTransform: "none" }}
          onClick={() => {
            if (elementType !== "") {
              handleAddProps({
                elementProps,
                elementType,
                override,
                gptModel: selectedGPTModel,
                selectedFile,
                accountId,
                viewSetId,
              })
            } else {
              enqueueSnackbar("Please select an element type", {
                variant: "warning",
              })
            }
          }}
        >
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModelEditAddPropertiesDialog
